interface ErrorMessageInputProps {
  message: string | undefined
}

export const ErrorMessageInput = ({ message }: ErrorMessageInputProps) => <span className="text-red-400 text-xs">{message || ''}</span>
